var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-horizontal-blocker'),_c('router-view'),_c('v-cookies',{attrs:{"gatag":'G-6JT1M1TK1E'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }